export const SUBSCRIPTION_TRANSLATIONS = {
    paymentRequiredDetail: {
        "pt-BR": "Conclua a assinatura do plano escolhido para continuar.",
        en: "Complete the subscription for your chosen plan to continue.",
        es: "Completa la suscripción del plan elegido para continuar.",
        de: "Schließen Sie das Abonnement für den von Ihnen gewählten Plan ab, um fortfahren zu können.",
    },
    trialExpiredDetail: {
        "pt-BR": "Seu período de experimentação encerrou. Assine o plano Básico para continuar.",
        en: "Your trial period has ended. Subscribe to the Basic plan to continue.",
        es: "Tu período de prueba ha finalizado. Suscríbete al plan Básico para continuar.",
        de: "Ihr Testzeitraum ist abgelaufen. Abonnieren Sie den Basic-Plan, um fortzufahren.",
    },
    planLimitReachedDetail: {
        "pt-BR": "Limite de pacientes do plano atingido.",
        en: "Your plan's patient limit has been reached.",
        es: "Se alcanzó el límite de pacientes del plan.",
        de: "Das Patientenlimit Ihres Plans wurde erreicht.",
    },
    cardBillingGapFullName: {
        "pt-BR": "Nome completo",
        en: "Full name",
        es: "Nombre completo",
        de: "Vollständiger Name",
    },
    cardBillingGapEmail: {
        "pt-BR": "E-mail",
        en: "Email",
        es: "Correo electrónico",
        de: "E-Mail",
    },
    cardBillingGapCpf: {
        "pt-BR": "CPF",
        en: "CPF",
        es: "CPF",
        de: "CPF",
    },
    cardBillingGapPhone: {
        "pt-BR": "Celular com DDD",
        en: "Mobile number with area code",
        es: "Celular con código de área",
        de: "Handynummer mit Vorwahl",
    },
    cardBillingGapAddress: {
        "pt-BR": "Endereço completo",
        en: "Full address",
        es: "Dirección completa",
        de: "Vollständige Adresse",
    },
    cardBillingGapPostalCode: {
        "pt-BR": "CEP",
        en: "Postal code",
        es: "Código postal",
        de: "Postleitzahl",
    },
    cardBillingGapStreetNumber: {
        "pt-BR": "Número do endereço",
        en: "Street number",
        es: "Número de la dirección",
        de: "Hausnummer",
    },
    planNameFree: {
        "pt-BR": "Gratuito",
        en: "Free",
        es: "Gratuito",
        de: "Frei",
    },
    planNameBasic: {
        "pt-BR": "Básico",
        en: "Basic",
        es: "Básico",
        de: "Essentiell",
    },
    planNamePro: {
        "pt-BR": "Pro",
        en: "Pro",
        es: "Pro",
        de: "Profi",
    },
    planNameClinic: {
        "pt-BR": "Clínica",
        en: "Clinic",
        es: "Clínica",
        de: "Klinik",
    },
    planPriceFree: {
        "pt-BR": "Grátis",
        en: "Free",
        es: "Gratis",
        de: "Frei",
    },
    unlimitedPatients: {
        "pt-BR": "Ilimitado",
        en: "Unlimited",
        es: "Ilimitado",
        de: "Unbegrenzt",
    },
    perMonthPeriod: {
        "pt-BR": "/mês",
        en: "/month",
        es: "/mes",
        de: "/Monat",
    },
    planAdjustmentDismissLoading: {
        "pt-BR": "Fechando…",
        en: "Closing…",
        es: "Cerrando…",
        de: "Schließen…",
    },
    planAdjustmentDismiss: {
        "pt-BR": "Entendi",
        en: "Got it",
        es: "Entendido",
        de: "Habe es",
    },
} as const;
